import { ITripPassengerDetail, ITripRequestRidersHelper } from 'src/types'

export const TRIP_RIDERS_DEFAULT_VALUE: ITripPassengerDetail = {
  tripRequestRiders: [
    {
      fareType: 'Wallet',
      riderType: 'Adult',
      totalRider: 1
    }
  ],
  attendant: false,
  disabilityApproved: false
}

export const tripRequestRidersHelper = (tripPassengersDeitail: ITripPassengerDetail): ITripRequestRidersHelper => {
  if (undefined) {
    return {
      riders: [],
      totalRiders: 0
    }
  }
  const tripRequestRiders = tripPassengersDeitail.tripRequestRiders
  const totalRiders = tripRequestRiders.reduce((partialSum, n) => partialSum + n.totalRider, 0)
  return {
    riders: tripRequestRiders,
    totalRiders
  }
}



// WEBPACK FOOTER //
// ./src/utils/group-rider.ts